import React, {Component} from 'react';

class Doc extends Component {
    render(){
        var {teamImage, fileName} = this.props;
        return(
            <div className="whitepaper">
                <div style={{position: 'relative'}}>
                    <img style={{zIndex: '32', left: '0px', position: 'relative'}} src={require ("../../img/docs/" + teamImage )} alt="team"  top="0"/>
                    <img style={{zIndex: '100', right: '20px', position: 'absolute', bottom: '20px', width: '40px'}} src={require ("../../img/pdf.png")} alt="pdf" top="0"/>
                </div>
                <div className="hover_content" style={{height: '80%', zIndex: '101'}}>
                    <div >
                        <a href={"/docs/" + fileName}>
                            <i className={`ti-import`}></i>
                            <h3 className="f_p f_size_10 f_600">{'Download'}</h3>
                            <h5>{fileName}</h5>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}
export default Doc;